"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _reactLocalizeRedux = require("react-localize-redux");

require("./image.css");

/** For displaying images of different Edelweiss entities (catalogs, titles, communities, etc) */
var Image =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Image, _React$Component);

  function Image() {
    (0, _classCallCheck2.default)(this, Image);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Image).apply(this, arguments));
  }

  (0, _createClass2.default)(Image, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "treeline-image"
      }, _react.default.createElement(_antd.Spin, {
        spinning: this.props.isLoading
      }, this.getImage()));
    }
  }, {
    key: "getImage",
    value: function getImage() {
      var _this$props = this.props,
          imageSizeClassName = _this$props.imageSizeClassName,
          imageUri = _this$props.imageUri;
      var names = "image-container flex-center gray-background ".concat(imageSizeClassName);
      return _react.default.createElement("div", {
        className: names,
        style: this.getImageContainerStyle()
      }, imageUri ? _react.default.createElement("img", {
        alt: this.props.alt,
        src: this.props.imageUri
      }) : this.getNoImageMessage());
    }
  }, {
    key: "getImageContainerStyle",
    value: function getImageContainerStyle() {
      var _this$props2 = this.props,
          height = _this$props2.height,
          width = _this$props2.width;
      var style = {};

      if (height) {
        style.height = height;
      }

      if (width) {
        style.width = width;
      }

      return style;
    }
  }, {
    key: "getNoImageMessage",
    value: function getNoImageMessage() {
      var noImageAvailableTranslationId = this.props.noImageAvailableTranslationId;

      if (typeof this.props.getHasNoImage === 'function') {
        return this.props.getHasNoImage();
      }

      return _react.default.createElement("div", {
        className: "acc-font bold flex-centered-content"
      }, _react.default.createElement("div", {
        className: "no-image"
      }, noImageAvailableTranslationId ? _react.default.createElement(_reactLocalizeRedux.Translate, {
        id: noImageAvailableTranslationId
      }) : 'No Image Available'));
    }
  }]);
  return Image;
}(_react.default.Component);

exports.default = Image;
Image.propTypes = {
  /** URI for the entity image */
  imageUri: _propTypes.default.string,

  /** External loading state */
  isLoading: _propTypes.default.bool,

  /** className that will be added to the image container <div>. Define css sizing rules in your project for the image and reference it here. */
  imageSizeClassName: _propTypes.default.string,

  /** () => Jsx; Overwrites the message to the user conveying that there is no image to display */
  getHasNoImage: _propTypes.default.func,

  /** Optionally define the height of the image container using inline 'height' style rule (string or number) */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Optionally define the width of the image container using inline 'width' style rule (string or number) */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Passed onto the underlying <img> as the alt property */
  alt: _propTypes.default.string,

  /** localization id for the "No Image Available" mesage */
  noImageAvailableTranslationId: _propTypes.default.string
};
Image.defaultProps = {
  isLoading: false,
  imageSizeClassName: '',
  alt: 'Edelweiss Entity'
};